<template>
  <router-view></router-view>
<!--  <el-config-provider :locale="locale">-->
<!--    <router-view />-->
<!--  </el-config-provider>-->
</template>

<!--<script setup>-->
<!--<script>-->
<!--import en from 'element-plus/es/locale/lang/en'-->
<!--// const locale = en-->

<!--// onMounted(() => {-->
<!--//   // Notification logic here-->
<!--//   // this.$notify(-->
<!--//   //   {-->
<!--//   //     component: NotificationSample,-->
<!--//   //     icon: 'nc-icon nc-app'-->
<!--//   //   })-->
<!--// })-->
<!--</script>-->

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  mounted () {
    // this.$notify(
    //   {
    //     component: NotificationSample,
    //     icon: 'nc-icon nc-app'
    //   })
  },
});
</script>
